module.exports = __webpack_public_path__ + "static/media/hands.cad41a54.jpg";